import { post } from "@rails/request.js"

export function trackBrowserEvent(payload, { urgent = false } = {}) {
  const eventsUrl = document.body?.dataset?.eventsUrl || '/events'

  if (urgent && sendBeacon(eventsUrl, payload)) return true

  return post(eventsUrl, {
    responseKind: 'json',
    body: payload,
  })
}

function sendBeacon(eventsUrl, payload) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
  if (!navigator.sendBeacon || !csrfToken) return false

  try {
    const body = new Blob(
      [JSON.stringify({ ...payload, authenticity_token: csrfToken })],
      { type: 'application/json' },
    )
    return navigator.sendBeacon(eventsUrl, body)
  } catch (error) {
    console.warn('Unable to queue browser analytics event', error)
    return false
  }
}
